'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//NOTE(rbickham11): This is not in the validators folder because it needs to call validators itself for children, 
//thus it would cause a circular dependency.

var get = require('lodash/get');
var findIndex = require('lodash/findIndex');
var isNil = require('lodash/isNil');
var intersection = require('lodash/intersection');

var ValidationSuccess = require('./validators/models/validation-success');
var ValidationFailure = require('./validators/models/validation-failure');

var validators = require('./validators');
var ValueValidationError = require('./models/value-validation-error');

module.exports = function selectValuesValid(value, validationOptions) {
  var selectOptions = validationOptions._selectOptions;

  if (!selectOptions || selectOptions.length === 0) {
    return new ValidationFailure('No select options were provided to the validation library');
  }

  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !Array.isArray(value)) {
    //Assume nested select
    var firstFieldKey = selectOptions[0].field;

    var keyParts = firstFieldKey.split('.');
    var valueKeyIndex = findIndex(keyParts, function (val) {
      return value[val];
    });
    var fieldKeyBase = keyParts.slice(0, valueKeyIndex).join('.');

    //NOTE (rbickham): Retrieves the relative key. Ex: languages.proficiency.level -> level
    var firstValue = get(value, firstFieldKey.slice(fieldKeyBase.length + 1));

    return validateSelectValue(firstValue, selectOptions, { fieldKeyBase: fieldKeyBase, originalValue: value });
  }

  return validateSelectValue(value, selectOptions);
};

function validateSelectValue(value, options) {
  var nestedParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
    //Assume single select
    var validOptions = options.map(function (o) {
      return o.value;
    });
    if (validOptions.includes(value)) {
      var selectedOption = options.find(function (o) {
        return o.value === value;
      });

      if (get(selectedOption, 'validation.rules', false)) {
        var nextField = selectedOption.validation.field;
        if (!nextField) return new ValidationFailure('There was an error validating a field in the nested select');

        var fieldKeyBase = nestedParams.fieldKeyBase,
            originalValue = nestedParams.originalValue;

        var lookupKey = nextField.slice(fieldKeyBase.length + 1);

        var nextValue = get(originalValue, lookupKey);

        if (!isNil(nextValue) || selectedOption.validation.rules.includes('required')) {
          var nextValueBaseValidationErrors = validateRulesForNestedValue(selectedOption.validation, nextValue, fieldKeyBase, nextField, false);

          if (nextValueBaseValidationErrors.length > 0) {
            return new ValidationFailure(nextValueBaseValidationErrors[0].messages);
          }
        }
      }

      if (selectedOption.options && selectedOption.options.length > 0) {
        var _nextField = selectedOption.options[0].field;

        var _fieldKeyBase = nestedParams.fieldKeyBase,
            _originalValue = nestedParams.originalValue;

        var _lookupKey = _nextField.slice(_fieldKeyBase.length + 1);

        var _nextValue = get(_originalValue, _lookupKey);

        return validateSelectValue(_nextValue, selectedOption.options, nestedParams);
      }

      return new ValidationSuccess();
    }

    return new ValidationFailure('Option ' + value + ' is invalid');
  }

  if (Array.isArray(value)) {
    //Assume multi select
    var _validOptions = options.map(function (o) {
      return o.value;
    });

    var invalidValues = value.filter(function (option) {
      return !_validOptions.includes(option);
    });

    if (invalidValues.length > 0) {
      return new ValidationFailure('Options ' + invalidValues.join(',') + ' are invalid');
    }

    var requiredOptions = options.filter(function (o) {
      return o.required;
    }).map(function (o) {
      return o.value;
    });

    if (intersection(value, requiredOptions).length !== requiredOptions.length) {
      return new ValidationFailure('Options ' + requiredOptions.join(',') + ' are required');
    }

    return new ValidationSuccess();
  }

  return new ValidationSuccess();
}

function validateRulesForNestedValue(validationOptions, value, fieldKey, failureKey) {
  var rules = validationOptions.rules || [];

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = rules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var ruleKey = _step.value;

      var validator = validators[ruleKey];
      if (!validator) {
        throw new Error('Validator with key ' + ruleKey + ' was not found');
      }

      var validationResult = validator(value, validationOptions);

      if (!validationResult.isValid) {
        return [new ValueValidationError(fieldKey, failureKey, validationResult.failureMessages)];
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return [];
}